import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';

@Injectable({
  providedIn: 'root'
})
export class EcatalogService {
  prefix = '/eshop_backend/eactalog';
  constructor(private http: HttpClient) {}
  //Manufacturers下拉数据
  getManufacturers(params: any) {
    return this.http.get<RequestModel>(this.prefix + '/getManufacturers2', {params});
  }
  //通过车型ID查询Models
  queryVehicleModelSeries(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryVehicleModelSeries', params);
  }
  //通过车型ID以及ModelId查询Types
  queryVehicleTypeSeries(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryVehicleTypeSeries', params);
  }
  //通过车牌号查询车辆信息
  queryVehiclesByKeyNumberPlate(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryVehiclesByKeyNumberPlate', params);
  }
   //通过车辆信息或者Anynumber查询Articles
  queryArticleByLinkTarget(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryArticleByLinkTarget', params);
  }
  // query Displacement
  queryDisplacement(params: any){
    return this.http.get<RequestModel>(this.prefix + '/listDisplacement', {params});
  }
  
  //通过VIN查询车辆信息
  queryVehiclesByVin(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryVehiclesByVin', params);
  }
  //关键字模糊查询车辆信息,例如AUDI
  linkageTargePage(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/linkageTargePage', params);
  }
  //通过Any Number查询Articles
  queryArticleByAnyNumber(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryArticleByAnyNumber', params);
  }

  ///获取Article Detail 信息
  queryArticleDetail(params: any) {
    const headers = new HttpHeaders().set('globalLoading', 'true');
    return this.http.post<RequestModel>(this.prefix + '/queryArticleDetail', params,{headers});
  }
  //articleId查询LinkingTargetManufacturer2
  queryArticleLinkedManufacturer2(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryArticleLinkedManufacturer2', params);
  }
  //获取Vehicle Linkages
  getVehicleModel(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryVehicleLinkages', params);
  }
  getCategorys(params: any) {
    return this.http.get<RequestModel>(this.prefix + '/getCategorys', {params});
  }

}
